export const DefaultSchedule = '* * * * * *';
export const TimeFormat = 'h:mm A';
